module.exports = __webpack_public_path__ + "static/ict@large-fa1ef5419bd065f3760f0dbde131eb1b.jpg";